import { Stack, styled } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

export const SelectedProfileStack = styled(Stack)(() => ({
  padding: '16px',
  background: NEW_COLORS.SECONDARY[50],
  border: `1px solid ${NEW_COLORS.GRAYSCALE[200]} `,
  borderTop: 'none',
}));
